<template>
  <AllRecordsTable
    :submit-button-text="currentTable.buttonText"
    :table-name="tableName"
    :link-slug="tableName"
    :title="currentTable.title"
    :columns="getColumns()"
    :order-fields="getOrderFields()"
    :rows="getRows()"
    :filter-fields="getFilterFields()"
  />
</template>

<script>
import AllRecordsTable from "@/_shared/widgets/AllRecordsTable";
import { lists } from "@/stock/constants";
export default {
  components: {
    AllRecordsTable,
  },
  data() {
    return {
      stockEntity: lists.stockEntity,
    };
  },
  computed: {
    tableName() {
      return this.$route.fullPath.substring(1);
    },
    currentTable() {
      return this.stockEntity.tablesContent[this.$route.fullPath];
    },
  },
  methods: {
    getColumns() {
      if (this.tableName !== "products") {
        return this.stockEntity.columnNames;
      }
      return [...this.stockEntity.columnNames, "Пол"];
    },
    getRows() {
      if (this.tableName !== "products") {
        return this.stockEntity.rowNames;
      }
      return [...this.stockEntity.rowNames, "gender"];
    },
    getOrderFields() {
      if (this.tableName !== "products") {
        return this.stockEntity.orderFields;
      }
      return {...this.stockEntity.orderFields, "Пол": "gender"};
    },
    getFilterFields() {
      if (this.tableName !== "products") {
        return this.stockEntity.filterFields;
      }
      return [
        ...this.stockEntity.filterFields,
        {
          name: "gender",
          title: "Пол",
          value: "",
          selectOptions: [
            {
              label: "Мужской",
              value: "муж.",
            },
            {
              label: "Женский",
              value: "жен.",
            },
            {
              label: "Унисекс",
              value: "унисекс",
            },
          ],
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/pages/StockEntityRecordsPage.vue